import React from 'react'
import styled from 'styled-components'
import { NBColorStrings } from 'enums/NBColor'
import { useDisplayTheme } from 'hooks/useUiState'

import { getAnnotationColor } from './utils'

const Icon = styled.div<{ $color?: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
`

interface AnnotationIconProps extends React.ComponentPropsWithoutRef<'div'> {
  color: NBColorStrings
}

const AnnotationIcon = ({ color, ...props }: AnnotationIconProps) => {
  const mode = useDisplayTheme()
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Icon $color={getAnnotationColor(color, mode)} {...props} />
}

export default AnnotationIcon
